import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-drug-inventory-window',
  templateUrl: './drug-inventory-window.component.html',
  styleUrls: ['./drug-inventory-window.component.css']
})
export class DrugInventoryWindowComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('/inventory/create');
  }

}
